import type { ExcJpmamV1DestinationKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const JPMAM_DESTINATION_BASE_PATH = getResolvedPath('/clearing/vendor/jpm/destination');

export const getJpmamDestinationPath: EntityPathBuilder<ExcJpmamV1DestinationKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return JPMAM_DESTINATION_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.destinationId) {
        return undefined;
      }

      return getResolvedPath(`${JPMAM_DESTINATION_BASE_PATH}/$destinationId`, context.keys);
    }
  }
};

export function getJpmamDestinationDetailPath(destinationId: string | undefined) {
  if (!destinationId) {
    return undefined;
  }

  return getJpmamDestinationPath({ kind: 'detail', keys: { destinationId } });
}
